<template>
  <div>
    <v-card flat class="mb-5" v-show="filter">
      <v-form>
        <v-row>
          <v-col cols="3" class="pb-0" xs="12">
            <v-autocomplete
              clearable
              hide-details
              dense
              outlined
              :items="regions"
              item-text="name"
              item-value="id"
              label="Region"
              v-model="form.region_id"
            ></v-autocomplete>
          </v-col>
          <v-col cols="3" class="pb-0" xs="12">
            <v-text-field
              clearable
              dense
              outlined
              label="Clinic"
              v-model="form.name"
            ></v-text-field>
          </v-col>
          <v-col cols="3" class="pb-0" xs="12">
            <v-text-field
              clearable
              dense
              outlined
              label="Email"
              v-model="form.email"
            ></v-text-field>
          </v-col>
          <v-col cols="3" class="pb-0" xs="12">
            <v-autocomplete
              clearable
              dense
              outlined
              :items="statuses"
              label="Status"
              item-text="title"
              item-value="title"
              v-model="form.status"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn
              class="mr-5"
              color="blue-grey darken-1"
              dark
              depressed
              @click="search"
              >Search</v-btn
            >
            <v-btn dark color="grey" depressed outlined @click="resetFilter"
              >Reset Filter</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="clinics"
      :options.sync="options"
      :server-items-length="totalClinics"
      :footer-props="footerProps"
      :loading="loading"
    >
      <template v-slot:item.name="{ item }">
        <v-btn text color="teal darken-2" @click="edit(item, false)">
          {{ item.name }}
        </v-btn>
      </template>

      <template v-slot:item.is_active="{ item }">
        <record-activator
          :item="item"
          table="clinics"
          @reload="paginate"
        ></record-activator>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="amber darken-2"
              v-bind="attrs"
              v-on="on"
              @click="edit(item)"
            >
              <v-icon>mdi-square-edit-outline</v-icon>
            </v-btn>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="red"
              v-bind="attrs"
              v-on="on"
              @click="remove(item)"
            >
              <v-icon>mdi-close-box-outline</v-icon>
            </v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <create-clinic ref="createClinicDialog" @reload="paginate"></create-clinic>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import createClinic from "../../../components/create-clinic.vue";
import RecordActivator from "../../../components/record-activator.vue";
export default {
  components: { createClinic, RecordActivator },
  data() {
    return {
      headers: [
        { text: "", value: "is_active", width: "50" },
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "Region", value: "region" },
        { text: "Sort Order", value: "sort_order" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      loading: true,
      footerProps: {
        itemsPerPageOptions: [25, 50, 100],
      },
      totalClinics: 0,
      options: {
        groupBy: [],
        groupDesc: [],
        itemsPerPage: 100,
        multiSort: false,
        mustSort: false,
        page: 1,
        sortBy: [],
        sortDesc: [],
      },
      filter: false,
      form: {},
      statuses: ["Active", "Inactive"],
    };
  },
  watch: {
    options: {
      handler() {
        this.paginate(this.form);
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      clinics: (state) => state.clinics.clinics,
      regions: (state) => state.regions.regions,
    }),
  },
  created() {
    this.form = this.initForm();
  },
  methods: {
    ...mapActions(["getClinics"]),
    resetFilter() {
      this.form = this.initForm();
      this.paginate();
    },
    search() {
      this.paginate(this.form);
    },
    initForm() {
      return {
        name: "",
        email: "",
        status: "",
        region_id: "",
      };
    },
    paginate(params = {}) {
      this.loading = true;
      this.getClinics({ ...this.options, ...params }).then((r) => {
        this.totalClinics = +r.data.total;
        this.options.itemsPerPage = +r.data.per_page;
        this.loading = false;
      });
    },
    edit(item, editable = true) {
      this.$refs.createClinicDialog.viewing = !editable;
      this.$refs.createClinicDialog.edit(item);
    },
    remove(item) {
      this.$confirm("Do you really want to delete this clinic?", {
        color: "error",
        title: "Warning",
      }).then((res) => {
        if (res) {
          window.axios.delete(`/api/clinics/${item.id}`).then(() => {
            this.paginate();
            this.$toast.success("Clinic deleted.");
          });
        }
      });
    },
  },
};
</script>